const Copyright = () => {
    return(
        <>
            <div className='copyright'>
                <p>Copyright ©️ 2024 by  Tagore Public School, Faridabad | Created By Entab Infotech: CampusCare®️   </p>
            </div>
        </>
    )
}
export default Copyright